var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Header extends Component {
    constructor() {
        super('Header', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('#btn-toggle-searchform').on('click', (event, button) => {
                event.preventDefault();
                $('#searchform').toggleClass('opened').find('input').get(0).focus();
            });
            $(window).on('scroll', (event) => {
                this.computeLogo();
            });
            this.computeLogo();
            this.success();
        });
    }
    computeLogo() {
        if ($(window).width() < 992 || $('#logo').hasClass('reduced'))
            return;
        let heightMax = 124;
        if ($(window).width() < 1400)
            heightMax = 94;
        if ($(window).width() < 1200)
            heightMax = 65;
        let heightDiff = heightMax - (window.scrollY * heightMax / $('header').height());
        if (heightDiff < 0)
            heightDiff = 0;
        $('#logo').css({
            'height': (85 + heightDiff) + 'px'
        });
        $('#main-menu').css({
            'top': $('header').height() + 'px',
            'max-height': 'calc(100vh - ' + $('header').height() + 'px)'
        });
        if (heightDiff != 0)
            $('body').css('padding-top', ($('header').height() + window.scrollY) + 'px');
    }
}
